import {
  TRESPONSE_TNA_DEFAULT_STEPS,
  TREQUEST_CREATE_TNA_TEMPLATE,
  TREQUEST_DELETE_TNA_TEMPLATE,
  TREQUEST_TNA_TEMPLATE_LISTING,
  TREQUEST_UPDATE_TNA_TEMPLATE_NAME,
  TRESPONSE_TNA_TEMPLATE_LISTING,
  TRESPONSE_TNA_TEMPLATE_DETAILS,
  TREQUEST_ADD_EDIT_TNA_TEMPLATE_STEP,
  TREQUEST_DELETE_TNA_TEMPLATE_STEP,
  TREQUEST_ASSIGN_TNA_TO_ORDERS,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TTnaTemplatesActionType } from './tna-templates.models';

export class GetTnaTemplateList implements Action {
  readonly type = TTnaTemplatesActionType.GetTnaTemplateList;
  constructor(public payload: TREQUEST_TNA_TEMPLATE_LISTING) {}
}

export class GetTnaTemplateListSuccess implements Action {
  readonly type = TTnaTemplatesActionType.GetTnaTemplateListSuccess;
  constructor(public tnaTemplateListRes: TRESPONSE_TNA_TEMPLATE_LISTING) {}
}

export class GetTnaTemplateListFailure implements Action {
  readonly type = TTnaTemplatesActionType.GetTnaTemplateListFailure;
  constructor() {}
}

export class SetUserPaginationOption implements Action {
  readonly type = TTnaTemplatesActionType.SetUserPaginationOption;
  constructor(public userPaginationOption: TUserPaginationOption) {}
}

export class UpdateTnaTemplateName implements Action {
  readonly type = TTnaTemplatesActionType.UpdateTnaTemplateName;
  constructor(
    public payload: TREQUEST_UPDATE_TNA_TEMPLATE_NAME,
    public fetchTnATemplatesPayload: TREQUEST_TNA_TEMPLATE_LISTING,
  ) {}
}

export class UpdateTnaTemplateNameSuccess implements Action {
  readonly type = TTnaTemplatesActionType.UpdateTnaTemplateNameSuccess;
}

export class UpdateTnaTemplateNameFailure implements Action {
  readonly type = TTnaTemplatesActionType.UpdateTnaTemplateNameFailure;
}

export class DeleteTnaTemplate implements Action {
  readonly type = TTnaTemplatesActionType.DeleteTnaTemplate;
  constructor(
    public payload: TREQUEST_DELETE_TNA_TEMPLATE,
    public fetchTnATemplatesPayload: TREQUEST_TNA_TEMPLATE_LISTING,
  ) {}
}

export class DeleteTnaTemplateSuccess implements Action {
  readonly type = TTnaTemplatesActionType.DeleteTnaTemplateSuccess;
}

export class DeleteTnaTemplateFailure implements Action {
  readonly type = TTnaTemplatesActionType.DeleteTnaTemplateFailure;
}

export class CopyTnaTemplate implements Action {
  readonly type = TTnaTemplatesActionType.CopyTnaTemplate;
  constructor(public templateId: string, public fetchTnATemplatesPayload?: TREQUEST_TNA_TEMPLATE_LISTING) {}
}

export class CopyTnaTemplateSuccess implements Action {
  readonly type = TTnaTemplatesActionType.CopyTnaTemplateSuccess;
}

export class CopyTnaTemplateFailure implements Action {
  readonly type = TTnaTemplatesActionType.CopyTnaTemplateFailure;
}

export class SetTnaDefaultStepsLoader implements Action {
  readonly type = TTnaTemplatesActionType.SetTnaDefaultStepsLoader;
  constructor(public showLoader: boolean) {}
}

export class GetTnaDefaultSteps implements Action {
  readonly type = TTnaTemplatesActionType.GetTnaDefaultSteps;
  constructor(public showLocalLoader?: boolean) {}
}

export class GetTnaDefaultStepsSuccess implements Action {
  readonly type = TTnaTemplatesActionType.GetTnaDefaultStepsSuccess;
  constructor(public defaultTnASteps: TRESPONSE_TNA_DEFAULT_STEPS) {}
}

export class GetTnaDefaultStepsFailure implements Action {
  readonly type = TTnaTemplatesActionType.GetTnaDefaultStepsFailure;
}

export class CreateTnATemplate implements Action {
  readonly type = TTnaTemplatesActionType.CreateTnATemplate;
  constructor(public payload: TREQUEST_CREATE_TNA_TEMPLATE) {}
}

export class CreateTnATemplateSuccess implements Action {
  readonly type = TTnaTemplatesActionType.CreateTnATemplateSuccess;
}

export class CreateTnATemplateFailure implements Action {
  readonly type = TTnaTemplatesActionType.CreateTnATemplateFailure;
}

export class GetTnaTemplateDetails implements Action {
  readonly type = TTnaTemplatesActionType.GetTnaTemplateDetails;
  constructor(public templateName: string) {}
}

export class GetTnaTemplateDetailsSuccess implements Action {
  readonly type = TTnaTemplatesActionType.GetTnaTemplateDetailsSuccess;
  constructor(public tnATemplateDetails: TRESPONSE_TNA_TEMPLATE_DETAILS) {}
}

export class GetTnaTemplateDetailsFailure implements Action {
  readonly type = TTnaTemplatesActionType.GetTnaTemplateDetailsFailure;
}

export class ClearTnaTemplateDetails implements Action {
  readonly type = TTnaTemplatesActionType.ClearTnaTemplateDetails;
  constructor() {}
}

export class AddEditTnaTemplateStep implements Action {
  readonly type = TTnaTemplatesActionType.AddEditTnaTemplateStep;
  constructor(public payload: TREQUEST_ADD_EDIT_TNA_TEMPLATE_STEP, public templateName: string) {}
}

export class AddEditTnaTemplateStepSuccess implements Action {
  readonly type = TTnaTemplatesActionType.AddEditTnaTemplateStepSuccess;
}

export class AddEditTnaTemplateStepFailure implements Action {
  readonly type = TTnaTemplatesActionType.AddEditTnaTemplateStepFailure;
}

export class DeleteTnaTemplateStep implements Action {
  readonly type = TTnaTemplatesActionType.DeleteTnaTemplateStep;
  constructor(public payload: TREQUEST_DELETE_TNA_TEMPLATE_STEP, public templateName: string) {}
}

export class DeleteTnaTemplateStepSuccess implements Action {
  readonly type = TTnaTemplatesActionType.DeleteTnaTemplateStepSuccess;
}

export class DeleteTnaTemplateStepFailure implements Action {
  readonly type = TTnaTemplatesActionType.DeleteTnaTemplateStepFailure;
}

export class DownloadTnaTemplateDetails implements Action {
  readonly type = TTnaTemplatesActionType.DownloadTnaTemplateDetails;
  constructor(public templateId: string) {}
}

export class DownloadTnaTemplateDetailsSuccess implements Action {
  readonly type = TTnaTemplatesActionType.DownloadTnaTemplateDetailsSuccess;
}

export class DownloadTnaTemplateDetailsFailure implements Action {
  readonly type = TTnaTemplatesActionType.DownloadTnaTemplateDetailsFailure;
}

export class AssignTnaToOrder implements Action {
  readonly type = TTnaTemplatesActionType.AssignTnaToOrder;
  constructor(public payload: TREQUEST_ASSIGN_TNA_TO_ORDERS) {}
}

export class AssignTnaToOrderSuccess implements Action {
  readonly type = TTnaTemplatesActionType.AssignTnaToOrderSuccess;
}

export class AssignTnaToOrderFailure implements Action {
  readonly type = TTnaTemplatesActionType.AssignTnaToOrderFailure;
}

export type TTnaTemplatesActions =
  | GetTnaTemplateList
  | GetTnaTemplateListSuccess
  | GetTnaTemplateListFailure
  | ClearTnaTemplateDetails
  | SetUserPaginationOption
  | UpdateTnaTemplateName
  | UpdateTnaTemplateNameSuccess
  | UpdateTnaTemplateNameFailure
  | DeleteTnaTemplate
  | DeleteTnaTemplateSuccess
  | DeleteTnaTemplateFailure
  | SetTnaDefaultStepsLoader
  | GetTnaDefaultSteps
  | GetTnaDefaultStepsSuccess
  | GetTnaDefaultStepsFailure
  | CreateTnATemplate
  | CreateTnATemplateSuccess
  | CreateTnATemplateFailure
  | GetTnaTemplateDetails
  | GetTnaTemplateDetailsSuccess
  | GetTnaTemplateDetailsFailure
  | AddEditTnaTemplateStep
  | AddEditTnaTemplateStepSuccess
  | AddEditTnaTemplateStepFailure
  | DeleteTnaTemplateStep
  | DeleteTnaTemplateStepSuccess
  | DeleteTnaTemplateStepFailure
  | DownloadTnaTemplateDetails
  | DownloadTnaTemplateDetailsSuccess
  | DownloadTnaTemplateDetailsFailure
  | AssignTnaToOrder
  | AssignTnaToOrderSuccess
  | AssignTnaToOrderFailure;
